import { render, staticRenderFns } from "./pop-client-order.vue?vue&type=template&id=67f03694&scoped=true"
import script from "./pop-client-order.vue?vue&type=script&lang=js"
export * from "./pop-client-order.vue?vue&type=script&lang=js"
import style0 from "./pop-client-order.vue?vue&type=style&index=0&id=67f03694&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f03694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f03694')) {
      api.createRecord('67f03694', component.options)
    } else {
      api.reload('67f03694', component.options)
    }
    module.hot.accept("./pop-client-order.vue?vue&type=template&id=67f03694&scoped=true", function () {
      api.rerender('67f03694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/pop-client-order.vue"
export default component.exports